















































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import DxDataGrid, {
  DxGrouping,
  DxSummary,
  DxGroupItem,
  DxSortByGroupSummaryInfo,
  DxSorting,
  DxRemoteOperations,
  DxColumn
} from 'devextreme-vue/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import { ClientAgentService } from '../../service/ClientAgentService';
import { QuestelServicesClient } from '@questelservices/common/dist';
import { DxButton } from 'devextreme-vue';
import { ClientAgentDto } from '../../models/client-agent/ClientAgentDto';
import { ClientAgentJurisdictionDto, JurisdictionType } from '@/models/client-agent/ClientAgentJurisdictionDto';
import { CountryDto } from '../../models/CountryDto';
import _ from 'lodash';
import { ClientAgentAliasDto } from '@/models/client-agent/ClientAgentAliasDto';
import { ClientDto } from '../../models/client/ClientDto';
import AgentInfoEdit from './agent-info-edit.vue';
import CreateNewAgent from './create-new-agent.vue';
import LinkNewAgent from './link-new-agent.vue';
import { ClientAgentInfoDto } from '../../models/client-agent/ClientAgentInfoDto';

@Component({
  components: {
    DxDataGrid,
    DxGrouping,
    DxSummary,
    DxGroupItem,
    DxSortByGroupSummaryInfo,
    DxSorting,
    DxRemoteOperations,
    DxColumn,
    DxButton,
    AgentInfoEdit,
    CreateNewAgent,
    LinkNewAgent
  }
})
export default class AgentSetup extends Vue {
    public $refs: Vue['$refs'] & {
        agentSetupDataGrid?: DxDataGrid;
        createNewAgent?: CreateNewAgent;
    } = {};

    agentSetupStore: CustomStore;
    hasData: boolean = false;
    clientAgentService: ClientAgentService;
    selectedClientId: Guid = '';
    showingAgentInfo: boolean = false;
    clientAgentInfo: ClientAgentInfoDto = new ClientAgentInfoDto();
    agentSetupList: ClientAgentDto[] = [];
    
    showingCreateNewAgent: boolean = false;        
    showingLinkNewAgent: boolean = false;

    constructor() {
        super();
        this.clientAgentService = new ClientAgentService();
        this.agentSetupStore = new CustomStore({         
            load: (options): Promise<any> => {
             return this.clientAgentService
                .agentSetup(options)
                .then(result => {
                    return result.data;
                })
                .catch(result => {
                    throw 'An error occurred loading the agent setup.';
                });
            }            
        });
    }

    private get dataGrid() {
      if (this.$refs.agentSetupDataGrid) {
        return this.$refs.agentSetupDataGrid.instance;
      }

      return undefined;
    }

    refreshDataGrid() {
      if (this.dataGrid) {
        this.dataGrid.refresh();
      }
    }

    onAgentSetupEdit(data: any ) {            
      this.clientAgentInfo = data;      
      this.showingAgentInfo = true;
    }

    hidingDialog() {    
      this.showingAgentInfo = false;
      this.refreshDataGrid();      
      if (this.$refs.createNewAgent) {
        (this.$refs.createNewAgent as any).refreshAgents();
      }      
    }

    showCreateNewAgent() {
      this.showingCreateNewAgent = true;
    }

    hidingCreateNewAgent() {
      this.showingCreateNewAgent = false;                
    }

    createNewAgentHidden(clientAgentInfo: ClientAgentInfoDto, createAgent: boolean) {
      if (!createAgent) {
        return;
      }

      this.showingAgentInfo = true;
      this.clientAgentInfo = clientAgentInfo;
    }

    showLinkAgent() {
      this.showingLinkNewAgent = true;
    }

    hidingLinkAgent() {
      this.showingLinkNewAgent = false;
    }

    linkAgentHidden() {
      this.refreshDataGrid();
    }



    processPrimaryAgentDisplay(data: any) {
      let result = "";
      if(data.Agent && data.Agent.AgentId != "00000000-0000-0000-0000-000000000000"
        && data.Agent.AgentName) {
        result = data.Agent.AgentName;
      }

      return result;
    }

    processAgentAlias(data: any) : string {
      let result = "";      
      if(data.ClientAgent && data.ClientAgent.ClientAgentAliases){
        result = _.find(data.ClientAgent.ClientAgentAliases, (item : ClientAgentAliasDto) => item.PrimaryAlias).AgentAlias;
      }

      return result;
    }

    processInJurisDictionDisplay(data: ClientAgentInfoDto, jurisdictionType: JurisdictionType): string {
      let result = "";      

      if(!data){
        return result;
      }

      if(jurisdictionType === JurisdictionType.In) {        
        if(data.Jurisdictions) {
          let filteredData = data.Jurisdictions.filter((item : ClientAgentJurisdictionDto) => item.InJurisdiction);
          filteredData.forEach((element : ClientAgentJurisdictionDto) => {
            result = (result ? `${result}, `: "") + element.Country.CountryCode;
          });    
        }    
      }
      else if(jurisdictionType === JurisdictionType.Out) {        
        if(data.Jurisdictions) {
          let filteredData = data.Jurisdictions.filter((item : ClientAgentJurisdictionDto) => !item.InJurisdiction);
          filteredData.forEach((element : ClientAgentJurisdictionDto) => {
            result = (result ? `${result}, `: "") + element.Country.CountryCode;
          });  
        }      
      }
      else if(jurisdictionType === JurisdictionType.Unset) {
        if(data.UnsetCountries) {
          data.UnsetCountries.forEach((element : CountryDto) => {
            result = (result ? `${result}, `: "") + element.CountryCode;
          });  
        }              
      }

      return result;
    }
}
